import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCatalogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/product-catalog', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCatalog(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`reservation/product-catalog/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCatalog(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`reservation/product-catalog/${id}/update`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
